import "./Pricing.css";
import starPng from "../../assets/sparkles.png";
import futurePng from "../../assets/plus-small.png";
import screen1 from "../../assets/1.png";
import screen2 from "../../assets/2.png";
import screen3 from "../../assets/3.png";
import screen4 from "../../assets/4.png";
import appStoreBadge from "../../assets/app-store-badge.svg";
import googlePlayBadge from "../../assets/google-play-badge.png";
import { Helmet } from "react-helmet";

const plans = ["Basic", "Standard", "Premium", "Enterprise"];

const rows = [
  {
    feature: "Rate levels",
    values: [
      "Competitive",
      "Industry-leading rates",
      "Attractive wholesale rates",
      "The most competitive wholesale rates ",
    ],
  },
  {
    feature: "Monthly top-up commitment",
    values: ["0", "5000 USD", "15000 USD", "25000 USD"],
  },
  { feature: "Multi-network coverage", values: ["+", "+", "+", "+"] },
  { feature: "Multi-language panel and app", values: ["+", "+", "+", "+"] },
  { feature: "Access to promotional bundles", values: ["+", "+", "+", "+"] },
  { feature: "Bank transfers with zero fees", values: ["+", "+", "+", "+"] },
  { feature: "Business credit card top-up", values: ["+", "+", "+", "+"] },
  { feature: "Multi-currency top-ups", values: ["+", "+", "+", "+"] },
  { feature: "Crypto currency top-ups", values: ["+", "+", "+", "+"] },
  { feature: "Multi-currency support", values: ["+", "+", "+", "+"] },
  { feature: "White‑label mobile app profiles", values: ["1", "1", "2", "5"] },
  { feature: "White‑label web panel profiles", values: ["1", "1", "2", "5"] },
  { feature: "Custom eSIM brand profiles", values: ["0", "0", "1", "2"] },
  { feature: "24/7 live chat support channel", values: ["+", "+", "+", "+"] },
  {
    feature: "24/7 Fast‑Track Escalation Support",
    values: ["+", "+", "+", "+"],
  },
  {
    feature: "Assigned Customer Success Manager",
    values: ["-", "-", "+", "+"],
  },
  {
    feature: "Personal Success Manager for your business",
    values: ["-", "-", "-", "+"],
  },
];

const appFeatures = [
  "Instant eSIM Activation — purchase and connect in minutes.",
  "Flexible, Affordable Data Plans — from short-term passes to long-term bundles.",
  "Multiple eSIM Options — choose from data packages (GB-based), unlimited bundles, subscriptions, or true pay-as-you-go, where you only pay for what you use.",
  "All-In-One Management — buy, activate, and manage all your eSIMs in one app.",
  "Easy Setup — install via QR code or activation code.",
  "Direct QR Sharing — share eSIM QR codes instantly with family, friends, or colleagues.",
  "Check eSIM Compatibility — verify device readiness directly in the app.",
  "Smart Auto-Renew — packages can automatically renew when the current one is about to run out, so you never lose connectivity.",
  "Usage Notifications — receive alerts before your package expires or data is nearly consumed.",
  "Privacy & Security — GDPR-compliant, no ads, no tracking.",
  "Multi-Language Support — app interface available in multiple languages.",
  "Global Coverage — reliable data in 190+ countries.",
  "Currency Comparison — view plan costs in different currencies.",
  "Smart Wallet Benefits — enjoy a permanent 3% discount when paying with your wallet.",
  "Wallet Transfers — send balance to another user — ideal for families and businesses.",
  "Location-based Guidance — if you consent to share your location, the app identifies your country/region and suggests the best plan.",
];

const upcoming = [
  "Purchase of phone numbers — support for inbound and outbound voice calls and SMS.",
  "Built-in support chat — direct contact with customer service from inside the app.",
  "In-app SMS — send and receive text messages directly in the application.",
  "In-app voice calls — make and receive phone calls without leaving the app.",
];

export default function Pricing() {
  const upcomingIconPng = "/assets/icons/upcoming.png";

  const left = appFeatures.slice(0, 8);
  const right = appFeatures.slice(8);

  const splitAtDash = (s) => {
    const re = /\s(—|–|-)\s/;
    const m = s.match(re);
    if (!m) return { head: s, tail: "" };
    const idx = m.index;

    return {
      head: s.slice(0, idx).trimEnd(),
      tail: s.slice(idx + m[0].length).trimStart(),
    };
  };

  return (
    <main className="pricing">
      <Helmet>
        <title>GlobTel Esim - Pricing</title>
      </Helmet>
      <header className="pricing__hero">
        <h1>Pricing</h1>
        <p className="pricing__lead">
          Everything you need to launch and grow digital mobile services –
          whether you’re a startup taking your first steps or an enterprise
          scaling globally.
        </p>
      </header>

      <section className="pricing__table-wrap" aria-label="Plan comparison">
        <div
          className="table-scroller"
          role="region"
          aria-labelledby="plansHeader"
          tabIndex={0}
        >
          <table className="pricing__table">
            <thead>
              <tr>
                <th id="plansHeader" scope="col" className="sticky-col">
                  Model
                </th>
                {plans.map((p) => (
                  <th key={p} scope="col" className="col-head">
                    {p}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((row, i) => (
                <tr key={row.feature}>
                  <th scope="row" className="sticky-col">
                    {row.feature}
                  </th>
                  {row.values.map((v, j) => (
                    <td key={j} data-plan={plans[j]}>
                      {v}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    </main>
  );
}
